import { HttpInterceptorFn } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';

/**
 * Tracking interceptor — attaches tracing headers to every outbound request.
 *
 *  - `X-Request-Id`: a unique id per request, for correlating client logs with
 *    backend traces and for future telemetry/audit hooks.
 *  - `X-Client-Timestamp`: ISO timestamp the request left the client.
 *
 * Purely additive: it never inspects responses and cannot affect behaviour, so
 * it is safe to apply to all requests (including external/excluded ones — a
 * trace id is harmless).
 */
export const trackingInterceptor: HttpInterceptorFn = (req, next) => {
  const tracked = req.clone({
    setHeaders: {
      'X-Request-Id': uuidv4(),
      'X-Client-Timestamp': new Date().toISOString(),
    },
  });
  return next(tracked);
};
